import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import useFetch from "../features/get";
import Header from "../../components/Header";
import { TbArrowsDownUp } from "react-icons/tb";
import { useLocation } from "react-router-dom";



function HotelList() {
  const { island } = useParams();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const navigate=useNavigate()

  const destination = params.get("destination");
  const checkIn = params.get("checkIn");
  const checkOut = params.get("checkOut");
  const { data, loading } = useFetch(
    `https://api.komorotel.com/api/hotels/search?destination=${destination}&checkIn=${checkIn}&checkOut=${checkOut}`
  );

  const [sortOrder, setSortOrder] = useState(null);
  const [maxPrice, setMaxPrice] = useState(1000);
  const [selectedType, setSelectedType] = useState("");

  const hotels = (data || [])
    .filter((hotel) => {
      return (
        hotel.cheapestPrice <= maxPrice &&
        (selectedType === "" || hotel.type === selectedType)
      );
    })
    .sort((a, b) => {
      if (sortOrder === "asc") return a.cheapestPrice - b.cheapestPrice;
      if (sortOrder === "desc") return b.cheapestPrice - a.cheapestPrice;
      return 0;
    });

  return (
    <>
      <Header />
      {!loading && hotels.length === 0 ? (

  <div className="flex flex-col items-center justify-center mt-28 text-center">

    {/* ICON */}
    <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center text-2xl mb-4">
      😕
    </div>

    {/* TITLE */}
    <h2 className="text-xl font-semibold text-gray-900">
      Aucun hôtel disponible
    </h2>

    {/* MESSAGE */}
    <p className="text-gray-500 mt-2 max-w-md">
      Aucun hébergement n’est disponible pour ces dates.
      Essayez de modifier vos dates ou votre destination.
    </p>

    {/* ACTIONS */}
    <div className="mt-6 flex gap-3">

      <button
        onClick={() => navigate('/')}
        className="
          px-4 py-2 rounded-lg text-sm
          bg-gray-100 text-gray-700
          hover:bg-gray-200 transition
        "
      >
        Modifier ma recherche
      </button>

      <a
        onClick={() => navigate('/')}
        href="/"
        className="
          px-4 py-2 rounded-lg text-sm
          bg-[#3A9D23] text-white
          hover:bg-[#33891E] transition
        "
      >
        Retour à l'accueil
      </a>

    </div>

  </div>
):(

      <div className="min-h-screen bg-gray-50 pt-28 px-4">

        <div className="max-w-7xl mx-auto flex gap-8">

          {/* SIDEBAR */}
          <div className="hidden lg:block w-[260px]">

            <div className="bg-white p-5 rounded-2xl shadow-sm sticky top-28">
              <h2 className="text-lg font-semibold mb-4">Filtres</h2>

              {/* Prix */}
              <div className="mb-6">
                <p className="text-sm font-medium mb-2">Prix max</p>
                <input
                  type="range"
                  min="50"
                  max="1000"
                  value={maxPrice}
                  onChange={(e) => setMaxPrice(e.target.value)}
                  className="w-full"
                />
                <p className="text-sm text-gray-500 mt-1">
                  Jusqu'à {maxPrice}€
                </p>
              </div>

              {/* Type */}
              <div>
                <p className="text-sm font-medium mb-2">Type</p>

                <div className="flex flex-col gap-2 text-sm">
                  <label>
                    <input
                      type="radio"
                      name="type"
                      onChange={() => setSelectedType("")}
                    />{" "}
                    Tous
                  </label>

                  <label>
                    <input
                      type="radio"
                      name="type"
                      onChange={() => setSelectedType("hotel")}
                    />{" "}
                    Hôtel
                  </label>

                  <label>
                    <input
                      type="radio"
                      name="type"
                      onChange={() => setSelectedType("villa")}
                    />{" "}
                    Villa
                  </label>
                </div>
              </div>
            </div>
          </div>

          {/* MAIN CONTENT */}
          <div className="flex-1">

            {/* Title + sort */}
            <div className="mb-8 flex items-center justify-between">
              <div className="flex flex-col">
                <h1 className="text-3xl md:text-4xl font-semibold tracking-tight text-gray-900">
                    Hôtels à{" "}
                    <span className="text-[#3A9D23]">
                      {destination || "Toutes les destinations"}
                    </span>
                </h1>

                <p className="text-sm text-gray-500 mt-1">
                    Découvrez les meilleurs hébergements disponibles
                </p>
                </div>

              <div className="flex items-center gap-3">
                <TbArrowsDownUp />
                <select
                  onChange={(e) => setSortOrder(e.target.value)}
                  className="border rounded-lg px-3 py-2 text-sm"
                >
                  <option value="">Trier</option>
                  <option value="asc">Prix croissant</option>
                  <option value="desc">Prix décroissant</option>
                </select>
              </div>
            </div>

            {/* GRID */}
            <div className="grid sm:grid-cols-2 xl:grid-cols-2 gap-8">
              {loading
                ? [...Array(6)].map((_, i) => (
                    <div
                      key={i}
                      className="h-[300px] bg-gray-200 rounded-2xl animate-pulse"
                    />
                  ))
                : hotels.map((hotel) => (
                    <a
                      key={hotel._id}
                      href={`/hotel/slug/${hotel.slug}?checkIn=${checkIn}&checkOut=${checkOut}`}
                      className="
                        group bg-white rounded-2xl overflow-hidden
                        shadow-sm hover:shadow-lg
                        transition duration-300
                        hover:-translate-y-1
                      "
                    >
                      {/* Image */}
                      <div className="h-[200px] overflow-hidden">
                        <img
                          src={hotel.photos[0]}
                          alt={hotel.name}
                          className="w-full h-full object-cover transition duration-500 group-hover:scale-105"
                        />
                      </div>

                      {/* Content */}
                      <div className="p-4">
                        <h3 className="text-lg font-semibold tracking-tight text-gray-900">
                          {hotel.name}
                        </h3>

                        <p className="text-sm text-gray-500 mt-1">
                          {hotel.type}
                        </p>

                        <p className="text-sm text-gray-600 mt-2 line-clamp-2">
                          {hotel.desc}
                        </p>

                        <div className="flex items-center justify-between mt-4">
                          <span className="text-base font-semibold text-gray-900">
                            {hotel.cheapestPrice}€
                          </span>
                          <span className="text-sm text-gray-500">
                            / nuit
                          </span>
                        </div>
                      </div>
                    </a>
                  ))}
            </div>

          </div>
        </div>
      </div>
    )}   
    </>
  );
}

export default HotelList;